/**
 * Returns the first non-empty array from the provided options.
 * An array is considered empty if it is null, undefined, or has length 0.
 * @param arrays - Two or more arrays to check
 * @returns The first non-empty array, or undefined if all arrays are empty
 */
export function firstNonEmpty<T>(...arrays: (T[] | null | undefined)[]): T[] | undefined {
  for (const arr of arrays) {
    if (arr && arr.length > 0) {
      return arr
    }
  }
  return undefined
}
